import { Component, signal } from '@angular/core';
import { AppMaterialModule } from '../../../../shared/material/app-material.module';
import {
  ReactiveFormsModule,
  FormBuilder,
  FormGroup,
  Validators,
} from '@angular/forms';
import { Router } from '@angular/router';
import { LoginService } from '../../../../core/services/login.service';
import { matchingPasswordsValidator } from '../../../../core/utils/password-match.validator';
import { NotifierService } from '../../../../core/services/notifier.service';

@Component({
  selector: 'app-recover-password',
  standalone: true,
  imports: [ReactiveFormsModule, AppMaterialModule],
  templateUrl: './recover-password.component.html',
  styleUrl: './recover-password.component.scss',
})
export class RecoverPasswordComponent {
  recoverPasswordForm: FormGroup;
  hideNewPassword = signal(true);
  hideConfirmationPassword = signal(true);
  isSubmitting = signal(false);
  isLoading = signal(false);

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private loginService: LoginService,
    private notifier: NotifierService
  ) {
    this.recoverPasswordForm = this.fb.group(
      {
        newPassword: ['', [Validators.required, Validators.minLength(8)]],
        confirmationPassword: [
          '',
          [Validators.required, Validators.minLength(8)],
        ],
      },
      {
        validators: matchingPasswordsValidator(
          'newPassword',
          'confirmationPassword'
        ),
      }
    );
  }

  toggleVisibility(field: 'newPassword' | 'confirmationPassword') {
    if (field === 'newPassword') {
      this.hideNewPassword.set(!this.hideNewPassword());
    } else {
      this.hideConfirmationPassword.set(!this.hideConfirmationPassword());
    }
  }

  get passwordsDontMatch(): boolean {
    const newPassword = this.recoverPasswordForm.get('newPassword')?.value;
    const confirmationPassword = this.recoverPasswordForm.get(
      'confirmationPassword'
    )?.value;
    return (
      newPassword &&
      confirmationPassword &&
      newPassword !== confirmationPassword
    );
  }

  onSubmit() {
    if (this.recoverPasswordForm.invalid || this.passwordsDontMatch) {
      this.recoverPasswordForm.markAllAsTouched();
      return;
    }
    this.isLoading.set(true);

    const newPassword = this.recoverPasswordForm.get('newPassword')?.value;
    const hash = this.getHashFromUrl();

    this.isSubmitting.set(true);

    this.loginService.updatePassword(hash, newPassword).subscribe(
      () => {
        this.notifier.showNotification({
          message: 'Senha atualizada com sucesso!',
          alternative: 'Efetue o login novamente.',
          messageType: 'successNotifier',
        });
        this.router.navigate(['/login']); // Redireciona para o login
      },
      (error) => {
        this.notifier.showNotification({
          message: 'Falha ao atualizar a senha.',
          alternative: 'Tente novamente.',
          messageType: 'errorNotifier',
        });
      },
      () => {
        this.isSubmitting.set(false);
      }
    );
  }

  goToUrl() {
    this.router.navigateByUrl('login');
  }

  private getHashFromUrl(): string {
    const urlSegments = this.router.url.split('/');
    return urlSegments[urlSegments.length - 1];
  }
}
